import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { map } from "rxjs/operators";
import { Subject } from "rxjs";

import { ADPResourceService as ResourceService } from 'digital-core';
import { HeaderFactoryService } from './header-factory.service';
import { ConfigService } from './config.service';
import {  SalesApplication } from "../models";


@Injectable()
export class SalesApplicationService {
  public saveApplicationObservable = new Subject<any>();

  constructor(
    private httpsClient: HttpClient,
    private headerService: HeaderFactoryService,
    private configService: ConfigService,
    private resourceService: ResourceService,
  
  ) {}

  public retrieveSalesApplications(resource?: ResourceService) {
    // return this.ALL_APPLICATIONS;
    let dateFormat,dateTimeFormat;
    if (resource == null) {
      dateFormat = this.resourceService.getPortalSetting(
        "Client_DateFormat"
      ).Value;
      dateTimeFormat = this.resourceService.getPortalSetting(
        "Client_DateTimeFormat"
      ).Value;
    }
    else{
      dateFormat = resource.getPortalSetting(
        "Client_DateFormat"
      ).Value;
      dateTimeFormat = resource.getPortalSetting(
        "Client_DateTimeFormat"
      ).Value;
    }
    let result = this.httpsClient
      .get<SalesApplication[]>(
        `${this.configService.apiUrl}api/v${this.configService.apiVersion}/saleApplication/byAgent`,
        this.headerService.getAuthorizationHeaderOptions()
      )
      .pipe(
        map((res) => {
          return res.map((sa) => {
            return new SalesApplication(sa, dateFormat, dateTimeFormat, this.resourceService);
          });
        })
      );
    return result;
  }

  public deleteSaleApplication(saleApplicationId: string) {
    return this.httpsClient.delete(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion}/saleApplication/${saleApplicationId}`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }
}
